import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	duplicateFieldsHeader: {
		id: 'native-issue-table.duplicate-fields-header',
		defaultMessage: 'Duplicate fields',
		description: 'Popup header for duplicate fields',
	},
	duplicateFieldsContent: {
		id: 'native-issue-table.duplicate-fields-content',
		defaultMessage: 'Configure columns to remove duplicates',
		description:
			'Description on duplciate fields popup that describes how to configure columns to remove duplicates',
	},
});
